// Global design-system stylesheet FIRST (tokens + preflight; see
// src/app/styles/AGENTS.md). Loaded once here — modules are lazy chunks, so a
// per-module import would flash unstyled content on route transitions.
import './app/styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { loadRuntimeConfig } from './runtime-config';

// Load runtime config (issuer/clientId/apiBase) BEFORE first render so the OIDC
// provider is configured up front — the one async step at bootstrap (LD-2/§4.2).
async function bootstrap(): Promise<void> {
  const config = await loadRuntimeConfig();
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Admin shell root element (#root) was not found.');
  }
  createRoot(container).render(
    <StrictMode>
      <App config={config} />
    </StrictMode>,
  );
}

void bootstrap();
